import React, { useMemo } from 'react';
import { history } from '@umijs/max';
import Marquee from 'react-fast-marquee';

const OptimizedMarquee = () => {
  const marqueeContent = useMemo(
    () => (
      <span
        style={{
          fontSize: 13,
          letterSpacing: '0.2em',
          display: 'inline-block',
          willChange: 'transform',
        }}
      >
        每一起严重事故的背后，必然有
        <span style={{ fontWeight: 'bold' }}>29次轻微事故</span>和
        <span style={{ fontWeight: 'bold' }}>300起未遂先兆</span>以及
        <span style={{ fontWeight: 'bold' }}>1000起事故隐患</span>。
        <a
          style={{
            marginRight: '15px',
            pointerEvents: 'auto',
          }}
          onClick={() => history.push('/rd/deliveryQuality/incidentResponse')}
        >
          📞 联系值班人员
        </a>
      </span>
    ),
    [],
  );

  return (
    <Marquee
      pauseOnHover
      gradient={false}
      speed={30}
      delay={2}
      style={{
        overflow: 'hidden',
        backfaceVisibility: 'hidden',
        transform: 'translateZ(0)',
      }}
    >
      {marqueeContent}
    </Marquee>
  );
};

export default OptimizedMarquee;
